import { gql } from '@apollo/client';
import { query } from '../../../../Services/Gateway/Apollo';

const IS_DOMAIN_INTERNAL = gql`
  query IsDomainInternal($domain: String!) {
    isDomainInternal(domain: $domain) {
      isDomainInternal
    }
  }
`;

/**
 * Apollo request
 */
const isDomainInternalQuery = async ({ variables }) => {
  try {
    const { data } = await query({
      query: IS_DOMAIN_INTERNAL,
      variables: variables.isDomainInternal,
    });

    return data.isDomainInternal;
  } catch (error) {
    throw new Error('Failed to query domain whitelist', error);
  }
};

export default isDomainInternalQuery;
